"use client";

import { create } from "zustand";

type CreateCollectionModalState = {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  setOpen: (open: boolean) => void;
};

export const useCreateCollectionModalStore = create<CreateCollectionModalState>((set) => ({
  isOpen: false,
  openModal: () => set({ isOpen: true }),
  closeModal: () => set({ isOpen: false }),
  setOpen: (open) => set({ isOpen: open }),
}));
